import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import {CallsListItem} from '@components/call-card/search/CallsListItem';
import CrmSupportsCloudStore from 'stores/crm/CrmSupportsCloudStore';
import AuthStore from 'stores/AuthStore';
import {Call} from '@store/call-card/Call';
import {LibraryId} from '@store/@types/records/Library';
import FileUploadStore from 'stores/files/FileUploadStore';
import {List} from 'immutable';

interface CallsListItemContainerProps {
  fileUpload: any;
  libraryId?: LibraryId;
  isLibrarySearch?: boolean;
}

@connectToStores
class CallsListItemContainer extends React.PureComponent<
  CallsListItemContainerProps & ReturnType<typeof CallsListItemContainer.getPropsFromStores>
> {
  static getStores() {
    return [CrmSupportsCloudStore, AuthStore, FileUploadStore];
  }

  static getPropsFromStores(props: CallsListItemContainerProps) {
    const supportsCrmSync = CrmSupportsCloudStore.getState().get('supportsCrmSync');
    const {user} = AuthStore.getState();
    const tags = FileUploadStore.getState().callTags.get(props.fileUpload?.id, List());
    return {
      call: new Call(props.fileUpload),
      sessionUser: user,
      supportsCrmSync,
      libraryTags: tags.filter(t =>
        props.libraryId ? t.library_id.toString() === props.libraryId.toString() : true
      ),
    };
  }

  render() {
    // If we didn't specify a libraryId, then just pick the first.
    // But only if we're using library search
    const libraryId =
      this.props.libraryId ?? this.props.isLibrarySearch
        ? this.props.libraryTags.first()?.library_id.toString()
        : undefined;
    return <CallsListItem {...this.props} libraryId={libraryId} />;
  }
}

export default CallsListItemContainer as unknown as React.FC<CallsListItemContainerProps>;
